import { MasterButton } from "App/Component/ui";
import { instance4 } from "App/constants";
import { defaultDateInputDisplay, isNull, oneMonthBeforeToday } from "App/utils/helpers";
import moment from "moment";
import {
  STATUS_TRANSAKSI_DISETUJUI,
  STATUS_TRANSAKSI_PENGAJUAN,
  STATUS_TRANSAKSI_PEMBELIAN,
  STATUS_TRANSAKSI_SELESAI,
} from "../PurchaseOrder/helpers";
import { STATUS_TRANSAKSI_DRAFT } from "../RequestFixedAsset/helpers";
import React from "react";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/wmsAsset/po/list";
export const urlDelete = "/wmsAsset/po/delete_po";

export const RESET_STATE_FORM_FILTER = {
  id: "",
  idpo: "",
  pages: 1,
  limit: 10,
  supplier_id: "",
  pembelian_id: "",
  gudang_id: "",
  unit_id: "",
  status_transaksi: "",
  status_name: "Semua",
  nomorPO: "",
  jumlah: 10,
  offset: 2,
  halaman: 1,
  gudang: "Pilih Gudang",
  unit: "Pilih Unit",
  supplier: "Pilih Supplier",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: moment(new Date()).local().toDate(),
};

export const statusTransaksi = [
  {
    value: "",
    label: "Semua",
  },
  {
    value: 1,
    label: "Draft",
  },
  {
    value: 2,
    label: "Di Setujui",
  },
  {
    value: 3,
    label: "Pengadaan",
  },
  {
    value: 4,
    label: "Selesai",
  },
];

export const getByFilterPO = async (
  formFilter,
  pages,
  limit,
  pembelian_id = 2
) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      pembelian_id: formFilter?.id,
      idpo: formFilter?.idpo,
      nomorPO: formFilter?.nomorPO,
      status_transaksi: pembelian_id === 0 ? "2" : formFilter.status_transaksi,
      supplier_id: formFilter?.supplier_id,
      gudang_id: formFilter?.gudang_id,
      unit_id: formFilter?.unit_id,
      tglAwal: isNull(formFilter.tglAwal)
        ? ""
        : startOfDay(formFilter.tglAwal),
      tglAkhir: isNull(formFilter.tglAkhir)
        ? ""
        : lastOfDay(formFilter.tglAkhir),
      offset: pages - 1,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePoById = async (id) => {
  try {
    const api = await instance4.get(`${urlDelete}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus po",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "pembelian_id",
    disablePadding: false,
    label: "PEMBELIAN ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nomorPO",
    disablePadding: false,
    label: "NOMOR PO",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "unit",
    disablePadding: false,
    label: "UNIT",
    align: "left",
    minWidth: "150px",
  },
  // {
  //   id: "gudang",
  //   disablePadding: false,
  //   label: "GUDANG",
  //   align: "left",
  //   minWidth: "150px",
  // },
  {
    id: "produsen",
    disablePadding: false,
    label: "PRODUSEN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "suplier",
    disablePadding: false,
    label: "SUPPLIER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_transaksi",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "processedBy",
    disablePadding: false,
    label: "DIPROSES OLEH",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "total_harga",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const RenderStatusPoBadge = ({ status }) => {
  if (status === STATUS_TRANSAKSI_DRAFT) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DRAFT"}
        color={"secondary"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PENGAJUAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PENGAJUAN"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_DISETUJUI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"DISETUJUI"}
        color={"lightgreen"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_PEMBELIAN) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"PEMBELIAN"}
        color={"warning"}
        type="button"
        disabled
      />
    );
  } else if (status === STATUS_TRANSAKSI_SELESAI) {
    return (
      <MasterButton
        style={{ borderRadius: 20 }}
        name={"SELESAI"}
        color={"green"}
        type="button"
        disabled
      />
    );
  } else {
    return <p> Tidak ditemukan</p>;
  }
};

export const getNotifPOFA = async ({ id }) => {
  const api = await getByFilterPO({ idpo: id, status_transaksi:"" }, 1, 1);
  if (api.state) {
    const rowsData = api.data[0];
    const dataProps = {
      idreq: rowsData?.id_request,
      idpo: rowsData?.id,
      nomorPo: rowsData?.nomorPo,
      date: defaultDateInputDisplay(rowsData?.date, true),
      // gudang_id: rowsData?.gudang_id,
      // gudang: rowsData?.gudang,
      produsen: rowsData?.produsen,
      produsen_id: rowsData?.produsen_id,
      supplier_id: rowsData?.supplier_id,
      supplier: rowsData?.supiler,
      unit_id: rowsData?.unit_id,
      unit: rowsData?.unit,
      penerima: rowsData?.penerima,
      remark: rowsData?.remark,
      type: "update",
      status: rowsData?.status,
      isOpenDraf: true,
      isProcess: rowsData?.status_transaksi === 0 ? false : true,
      jumlah: 0,
      tax: rowsData?.tax === null ? 0 : rowsData?.tax,
      total_jumlah: 0,
      status_transaksi: rowsData?.status_transaksi,
      isRequest: isNull(rowsData?.id_request) ? false : true,
    };
    return dataProps;
  } else {
    return null;
  }
};
